document.addEventListener('click', function(e) {
  var tab = e.target.closest('[data-psc-tab-trigger]');
  if (!tab) return;

  var key = tab.getAttribute('data-psc-tab-trigger');
  var sid = key.slice(0, key.lastIndexOf('-'));
  var section = document.querySelector('[data-psc-section-id="' + sid + '"]');
  if (!section) return;

  section.querySelectorAll('[data-psc-tab-trigger]').forEach(function(t) {
    t.classList.toggle('is-active', t === tab);
    t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
  });

  section.querySelectorAll('[data-psc-tab-panel]').forEach(function(panel) {
    var active = panel.getAttribute('data-psc-tab-panel') === key;
    if (active) {
      panel.setAttribute('data-psc-active', '');
      setTimeout(function() { initAllInPanel(panel); }, 50);
    } else {
      panel.removeAttribute('data-psc-active');
    }
  });
});

document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-psc-atc]');
  if (!btn || btn.disabled) return;
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;
  btn.disabled = true;
  var originalText = btn.textContent;
  btn.textContent = 'ADDING...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    btn.textContent = 'ADD TO CART';
    document.dispatchEvent(new CustomEvent('cart:updated'));
document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    setTimeout(function() { btn.disabled = false; btn.textContent = originalText; }, 1500);
  })
  .catch(function() { btn.disabled = false; btn.textContent = originalText; });
});

function pscGetCardWidth(panel) {
  var track = panel.querySelector('[data-psc-track]');
  var card = track && track.querySelector('[data-psc-card]');
  if (!card) return 0;
  return card.offsetWidth + (parseInt(getComputedStyle(track).gap) || 16);
}

function pscGetMaxOffset(panel) {
  var track = panel.querySelector('[data-psc-track]');
  if (!track) return 0;
  var cards = track.querySelectorAll('[data-psc-card]');
  if (!cards.length) return 0;

  var gap = parseInt(getComputedStyle(track).gap) || 16;
  var cardW = cards[0].offsetWidth;
  var totalTrackW = cards.length * cardW + (cards.length - 1) * gap;

  var carousel = panel.querySelector('.psc-carousel');
  var carouselW = carousel ? carousel.offsetWidth : panel.offsetWidth;

  return Math.max(0, totalTrackW - carouselW);
}

function pscApplyOffset(panel, offset, animate) {
  var track = panel.querySelector('[data-psc-track]');
  var progressBar = panel.querySelector('[data-psc-progress]');
  var prevBtn = panel.querySelector('[data-psc-prev]');
  var nextBtn = panel.querySelector('[data-psc-next]');
  if (!track) return;
  var max = pscGetMaxOffset(panel);
  var clamped = Math.min(Math.max(offset, 0), max);
  if (clamped !== 0) {
    console.log('[PSC] applyOffset', clamped, 'max:', max, 'panel:', panel.getAttribute('data-psc-tab-panel'), new Error().stack.split('\n')[2]);
  }
  panel._pscOffset = clamped;
  track.style.transition = animate ? 'transform 0.35s ease' : 'none';
  track.style.transform = 'translateX(-' + clamped + 'px)';
  if (progressBar) {
    var trackW = progressBar.parentElement.offsetWidth;
    var thumbW = progressBar.offsetWidth;
    var maxTranslate = trackW - thumbW;
    var translate = max > 0 ? (clamped / max) * maxTranslate : 0;
    progressBar.style.transform = 'translateX(' + translate + 'px)';
  }
  if (prevBtn) prevBtn.disabled = clamped <= 0;
  if (nextBtn) nextBtn.disabled = clamped >= max;
}

function initAllInPanel(panel) {
  panel.querySelectorAll('.psc-main').forEach(function(main) {
    initCarousel(main);
    initSelectors(main);
  });
}

function initCarousel(panel) {
  var track = panel.querySelector('[data-psc-track]');
  if (!track) return;

  if (panel._pscCarouselBound) return; // ← chequear primero

  var carousel = panel.querySelector('.psc-carousel');
  var carouselWidth = carousel ? carousel.offsetWidth : 0;
  if (carouselWidth === 0) {
    setTimeout(function() { initCarousel(panel); }, 100);
    return; // ← sale sin setear _pscCarouselBound
  }

  panel._pscCarouselBound = true; // ← solo se setea cuando hay width real

  pscApplyOffset(panel, 0, false);

  var prevBtn = panel.querySelector('[data-psc-prev]');
  var nextBtn = panel.querySelector('[data-psc-next]');
  if (prevBtn) prevBtn.addEventListener('click', function() {
    pscApplyOffset(panel, (panel._pscOffset || 0) - pscGetCardWidth(panel), true);
  });
  if (nextBtn) nextBtn.addEventListener('click', function() {
    pscApplyOffset(panel, (panel._pscOffset || 0) + pscGetCardWidth(panel), true);
  });
  var dragStartX = 0, dragStartOffset = 0, dragging = false;
  track.addEventListener('mousedown', function(e) {
    dragging = true; dragStartX = e.clientX; dragStartOffset = panel._pscOffset || 0;
    track.classList.add('is-dragging');
  });
  document.addEventListener('mousemove', function(e) {
    if (!dragging) return;
    pscApplyOffset(panel, dragStartOffset + (dragStartX - e.clientX), false);
  });
  document.addEventListener('mouseup', function() {
    if (!dragging) return; dragging = false; track.classList.remove('is-dragging');
  });
  track.addEventListener('touchstart', function(e) {
    dragStartX = e.touches[0].clientX; dragStartOffset = panel._pscOffset || 0;
  }, { passive: true });
  track.addEventListener('touchmove', function(e) {
    pscApplyOffset(panel, dragStartOffset + (dragStartX - e.touches[0].clientX), false);
  }, { passive: true });
  track.addEventListener('dragstart', function(e) { e.preventDefault(); });
  window.addEventListener('resize', function() {
    pscApplyOffset(panel, panel._pscOffset || 0, false);
  });
}

function pscGetVariants(productId) {
  return (window.__pscVariants && window.__pscVariants[productId]) ? window.__pscVariants[productId] : [];
}

function pscResolveVariant(panel, productId) {
  var variants = pscGetVariants(productId);
  if (!variants.length) return null;
  var atcBtn = panel.querySelector('[data-psc-atc]');
  if (!atcBtn) return null;
  var colorOptIdx = parseInt(atcBtn.getAttribute('data-color-opt-idx')) || 0;
  var hasCupsize = !!panel.querySelector('[data-psc-cup-selector]');
  var activeColor = panel.querySelector('[data-psc-swatch].is-active');
  var selectedColor = activeColor ? activeColor.getAttribute('data-color') : null;
  if (hasCupsize) {
    var cupBtn = panel.querySelector('[data-psc-cup].is-active');
    var bandBtn = panel.querySelector('[data-psc-band].is-active');
    if (!cupBtn || !bandBtn) return null;
    var target = (cupBtn.getAttribute('data-psc-cup') + '-' + bandBtn.getAttribute('data-psc-band')).toUpperCase();
    return variants.find(function(v) {
      if (!v.option2 || v.option2.toUpperCase() !== target) return false;
      if (!selectedColor) return true;
      return v['option' + (colorOptIdx + 1)] === selectedColor;
    }) || null;
  } else {
    var sizeBtn = panel.querySelector('[data-psc-size].is-active');
    var selectedSize = sizeBtn ? sizeBtn.getAttribute('data-psc-size') : null;
    return variants.find(function(v) {
      if (selectedSize && v.option2 !== selectedSize) return false;
      if (!selectedColor) return true;
      return v['option' + (colorOptIdx + 1)] === selectedColor;
    }) || null;
  }
}

function pscSyncAtc(panel, productId) {
  var atcBtn = panel.querySelector('[data-psc-atc]');
  if (!atcBtn) return;
  var variant = pscResolveVariant(panel, productId);
  var atcText = atcBtn.getAttribute('data-atc-text') || 'ADD TO CART';
  if (!variant) { atcBtn.disabled = true; atcBtn.textContent = atcText; return; }
  atcBtn.disabled = !variant.available;
  atcBtn.textContent = variant.available ? atcText : 'SOLD OUT';
  atcBtn.setAttribute('data-variant-id', variant.id);
}

function pscUpdateBands(panel, productId) {
  var variants = pscGetVariants(productId);
  var atcBtn = panel.querySelector('[data-psc-atc]');
  var colorOptIdx = atcBtn ? (parseInt(atcBtn.getAttribute('data-color-opt-idx')) || 0) : 0;
  var activeColor = panel.querySelector('[data-psc-swatch].is-active');
  var selectedColor = activeColor ? activeColor.getAttribute('data-color') : null;
  var cupBtn = panel.querySelector('[data-psc-cup].is-active');
  var selectedCup = cupBtn ? cupBtn.getAttribute('data-psc-cup') : null;
  panel.querySelectorAll('[data-psc-band]').forEach(function(btn) {
    var target = (selectedCup + '-' + btn.getAttribute('data-psc-band')).toUpperCase();
    var match = variants.find(function(v) {
      if (!v.option2 || v.option2.toUpperCase() !== target) return false;
      if (!selectedColor) return true;
      return v['option' + (colorOptIdx + 1)] === selectedColor;
    });
    if (!match) { btn.classList.add('is-hidden'); btn.classList.remove('is-active'); }
    else { btn.classList.remove('is-hidden'); btn.classList.toggle('is-oos', !match.available); }
  });
}

function initSelectors(panel) {
  if (panel._pscSelectorsBound) return;
  panel._pscSelectorsBound = true;
  var atcBtn = panel.querySelector('[data-psc-atc]');
  if (!atcBtn) return;
  var productId = atcBtn.getAttribute('data-product-id');
  var hasCupsize = !!panel.querySelector('[data-psc-cup-selector]');
  var firstSwatch = panel.querySelector('[data-psc-swatch]');
  if (firstSwatch) firstSwatch.classList.add('is-active');
  panel.querySelectorAll('[data-psc-swatch]').forEach(function(s) {
    s.addEventListener('click', function() {
      panel.querySelectorAll('[data-psc-swatch]').forEach(function(x) { x.classList.remove('is-active'); });
      s.classList.add('is-active');
      if (hasCupsize) pscUpdateBands(panel, productId);
      pscSyncAtc(panel, productId);
    });
  });
  if (hasCupsize) {
    var firstCup = panel.querySelector('[data-psc-cup]');
    if (firstCup) { firstCup.classList.add('is-active'); pscUpdateBands(panel, productId); }
    panel.querySelectorAll('[data-psc-cup]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        panel.querySelectorAll('[data-psc-cup]').forEach(function(x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        panel.querySelectorAll('[data-psc-band]').forEach(function(x) { x.classList.remove('is-active'); });
        pscUpdateBands(panel, productId);
        pscSyncAtc(panel, productId);
      });
    });
    panel.querySelectorAll('[data-psc-band]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.classList.contains('is-oos') || btn.classList.contains('is-hidden')) return;
        panel.querySelectorAll('[data-psc-band]').forEach(function(x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        pscSyncAtc(panel, productId);
      });
    });
  } else {
    var firstSize = panel.querySelector('[data-psc-size]');
    if (firstSize) firstSize.classList.add('is-active');
    panel.querySelectorAll('[data-psc-size]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.classList.contains('is-oos')) return;
        panel.querySelectorAll('[data-psc-size]').forEach(function(x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        pscSyncAtc(panel, productId);
      });
    });
  }
  pscSyncAtc(panel, productId);
}

(function() {
  function initFirstPanels() {
    document.querySelectorAll('[data-psc-section-id]').forEach(function(section) {
      var sid = section.getAttribute('data-psc-section-id');
      var firstPanel = section.querySelector('[data-psc-tab-panel="' + sid + '-1"]');
      var firstTab = section.querySelector('[data-psc-tab-trigger="' + sid + '-1"]');
      if (firstPanel) {
        section.querySelectorAll('[data-psc-tab-panel]').forEach(function(p) { p.removeAttribute('data-psc-active'); });
        firstPanel.setAttribute('data-psc-active', '');
        setTimeout(function() { initAllInPanel(firstPanel); }, 500);
      }
      if (firstTab) {
        section.querySelectorAll('[data-psc-tab-trigger]').forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        firstTab.classList.add('is-active');
        firstTab.setAttribute('aria-selected', 'true');
      }
    });
  }

  [0, 200, 500, 1000, 2000].forEach(function(delay) {
    setTimeout(initFirstPanels, delay);
  });
})();
window.addEventListener('load', function() {
  setTimeout(function() {
    document.querySelectorAll('.psc-hero__number-img[data-final-img]').forEach(function(el) {
      var url = el.getAttribute('data-final-img');
      console.log('Aplicando imagen:', url, el);
      el.style.backgroundImage = 'url("' + url + '")';
    });
  }, 100);
});